/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FieldOfSurgery {
    ENDODONTICS = 'Endodontics',
    GENERAL_DENTISTRY = 'General Dentistry',
    IMPLANT_SURGERY = 'Implant Surgery',
    ORAL_SURGERY = 'Oral Surgery',
    ORAL_HYGIENE = 'Oral Hygiene',
    ORTHODONTICS = 'Orthodontics',
    PERIODONTAL_SURGERY = 'Periodontal Surgery',
    PROSTHODONTICS = 'Prosthodontics',
    ABDMONINAL_LIPOSUCTION = 'Abdmoninal Liposuction',
    BLEPHAOPLASTY = 'Blephaoplasty',
    BODY_RESHPAING = 'Body Reshpaing',
    BODY_VASO_LIPO = 'Body Vaso Lipo',
    BREAST_ENLARGEMENT = 'Breast Enlargement',
    BREAST_REDUCTION = 'Breast Reduction',
    FACE_LIFT = 'Face Lift',
    FACIAL_BONE_RESPHAING = 'Facial Bone Resphaing',
    FACIAL_FAT_TRANSFER = 'Facial Fat Transfer',
    CHEST_LIPOSUCTION = 'Chest Liposuction',
    GYNECOMASTIA = 'Gynecomastia',
    SKIN_TIGHTENING = 'Skin Tightening',
    NECK_LIFT = 'Neck Lift',
    ALL_ON_4_DENTAL_IMPLANTS = 'All-on-4 Dental Implants',
    HAIR_TRANSPLANT = 'Hair Transplant',
    FACIAL_LIPOSUCTION = 'Facial Liposuction',
    OTHER = 'Other',
    RHINOPLASTY = 'Rhinoplasty',
}
